import React from "react";
import { CargarDatosPaginacion, BuscarPrestacionesPP } from "./action";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  Table, TableHeader, TableRow, TableHeaderColumn, TableBody, TableRowColumn, IconButton, Drawer,
  Card, CardHeader, CardText, CircularProgress, RaisedButton
} from "material-ui";

import styles from "../styles/styles";
import Editar from "material-ui/svg-icons/image/edit";
import Eliminar from "material-ui/svg-icons/action/delete";
import { OpenEliminarPrestacion, OpenEditarPrestacion, SeleccionarPrestacionEliminar, SeleccionarPrestacionEditar } from "../ActualizarArancel/GrillaBusqueda/actions";
import { ObtenerDetallePrestacionEdicion, ObtenerCentrosAtencionPorPrestacion } from "../ActualizarArancel/EditarPrestacionForm/actions";
import { ObtenerDetallePrestacionEliminacion, ObtenerCentrosAtencionPorPrestacionEli } from "../ActualizarArancel/EliminarPrestacionForm/actions";


// eslint-disable-next-line react/prefer-stateless-function
// eslint-disable-next-line react/no-multi-comp
class PaginacionBD extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      rowsPerPage: 5,
    };
  }

  componentWillMount() {
    //console.log("Component will mount PAGINACION V2");
    //console.log(this.props.totalPagina);
    this.props.dispatch(CargarDatosPaginacion(this.props.totalPagina));
    this.props.dispatch(BuscarPrestacionesPP(1, this.props.totalPagina));
    // this.sendData(this.props.prestacionesPP);
  }

  BuscarPrestacionesPP = (valor, totalPagina) => {
    this.props.dispatch(BuscarPrestacionesPP(valor, totalPagina));
  }


  EditEnabled = (idPrestacion, CodPrestacion, CodProf, TipoAtencion) => {
    let result = false;
    this.props.prestacionesPP.forEach((item) => {
      if (idPrestacion === item.IDPRESTACION && CodPrestacion === item.COD_PRESTADOR
        && (CodProf === item.PROF_CCOD || item.PROF_CCOD === "**") && (TipoAtencion === item.TIPO_ATENCION || typeof item.TIPO_ATENCION === "undefined")) {
        result = true;
      }
    });

    return result;
  }

  OpenEliminarPrestacion = (idPrestacion, CodPrestacion, CodProf, TipoAtencion) => {
    this.props.dispatch(SeleccionarPrestacionEliminar(idPrestacion));
    this.props.dispatch(ObtenerCentrosAtencionPorPrestacionEli(idPrestacion, CodPrestacion, CodProf, TipoAtencion, this.props.tipoArancel, this.props.rutInstitucion, this.props.isapre));
    this.props.dispatch(ObtenerDetallePrestacionEliminacion(idPrestacion, this.props.isapre, OpenEliminarPrestacion));
  }

  OpenEditarPrestacion = (idPrestacion, CodPrestacion, CodProf, TipoAtencion) => {
    this.props.dispatch(SeleccionarPrestacionEditar(idPrestacion));
    this.props.dispatch(ObtenerCentrosAtencionPorPrestacion(idPrestacion, CodPrestacion, CodProf, TipoAtencion, this.props.tipoArancel, this.props.rutInstitucion, this.props.isapre));
    this.props.dispatch(ObtenerDetallePrestacionEdicion(idPrestacion, this.props.isapre, OpenEditarPrestacion));
  }

  SetPaginacion = (pagenew, rowsPerPage) => {
    //console.log("NUMERO DE PAGINA");
    //console.log(pagenew)
    const idTableBodyc = this.props.idTableBody;
    const itemDesde = rowsPerPage * (pagenew - 1);
    const cantidad = rowsPerPage;
    const total = this.props.totalRows;

    if (document.getElementById(idTableBodyc)) {
      const menuListPrestaciones = [];
      const tableBodyRows = document.getElementById(idTableBodyc).querySelectorAll("tbody>tr");

      // this.sendData(menuListPrestaciones);


      for (let i = 0; i < total; i += 1) {
        let styleDisplay = "";
        if (i < itemDesde || i > (itemDesde + cantidad) - 1) {
          styleDisplay = "none";
        }
        if (tableBodyRows[i]) {
          tableBodyRows[i].style.display = styleDisplay;
        }
      }
      this.setState({ page: pagenew });
    }
  }

  // sendData = (i) => {
  //   this.props.parentCallback(i);
  // }

  render() {
    const itemsNumPages = [];
    let isInvisible = false;
    const cantPages = this.props.totalPage;
    //console.log(this.props.prestacionesPP);

    const menuListPrestaciones = [];
    this.props.prestacionesPP.map((row, index) => (
      menuListPrestaciones.push((
        <TableRow key={index}>
          <TableRowColumn id={row.ID} name={`ID_${row.ID}`} style={{ visibility: "hidden" }}>{row.ID}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusqueda1}>{row.COD_PRESTADOR}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusqueda2} title={row.GLOSA_CODPRESTADOR}>{row.GLOSA_CODPRESTADOR}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusqueda3}>{row.COD_ISAPRE}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusqueda4}>{row.PROF_CCOD}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusqueda5}>{row.VALOR}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusqueda7}>{row.UNIDAD === "VE" ? "VF" : row.UNIDAD}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusqueda6}>{row.TIPO_ATENCION === "A" ? "AMBULATORIA" : "HOSPITALARIA"}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusqueda8}>{(new Date(row.INICIO_VIG)).toLocaleDateString("en-GB", { timeZone: "UTC" })}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusqueda9}>{row.CENTRO_AT}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusqueda10}>
            {!this.EditEnabled(row.ID, row.COD_PRESTADOR, row.PROF_CCOD, row.TIPO_ATENCION) ?
              <IconButton
                iconStyle={styles.svgStyleResultado}
                style={styles.iconStyleResultado}
                // disabled={this.EditEnabled(row.ID, row.COD_PRESTADOR, row.PROF_CCOD, row.TIPO_ATENCION)}
                onClick={() => this.OpenEditarPrestacion(row.ID, row.COD_PRESTADOR, row.PROF_CCOD, row.TIPO_ATENCION)}
              >
                <Editar />
              </IconButton> : null}
          </TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusqueda11}>
            {!this.EditEnabled(row.ID, row.COD_PRESTADOR, row.PROF_CCOD, row.TIPO_ATENCION) ?
              <IconButton
                iconStyle={styles.svgStyleResultado}
                style={styles.iconStyleResultado}
                onClick={() => this.OpenEliminarPrestacion(row.ID, row.COD_PRESTADOR, row.PROF_CCOD, row.TIPO_ATENCION)}
              >
                <Eliminar />
              </IconButton> : null}
          </TableRowColumn>
        </TableRow>
      ))
    ));

    for (let i = 1; i <= cantPages; i += 1) {
      if ((cantPages - i > 3 || i > 3) &&
        i !== this.state.page && Math.abs(this.state.page - i) > 1 &&
        i > 2 && i < cantPages - 1) {
        if (!isInvisible) {
          itemsNumPages.push((
            <div key={`inviblebtn${i}`} style={{ width: 30, display: "inline-block" }}>.....</div>
          ));
        }
        isInvisible = true;
      } else {
        isInvisible = false;
        itemsNumPages.push((
          <RaisedButton
            key={`btn_pagination_${this.props.idTableBody}_${i}`}
            label={i}
            secondary
            labelStyle={this.props.labelStyleBtnPage}
            overlayStyle={this.props.overlayStyleBtnPage}
            rippleStyle={this.props.rippleStyleBtnPage}
            buttonStyle={this.props.buttonStyleBtnPage}
            style={this.props.styleBtnPage}
            disabled={i === this.state.page}
            onClick={() => { this.BuscarPrestacionesPP(i, this.props.totalPagina); this.SetPaginacion(i); }}
          />
        ));
      }
    }


    return (
      <div>
        {this.props.pageSize === 0 ?
          null :
          <div style={{ textAlign: "center", margin: "10px 0px" }}>
            <div style={{ overflow: "auto" }}>
              <div style={{ width: "1500px", overflowX: "auto", textAlign: "left" }}>
                <Table
                  fixedHeader
                  selectable={false}
                  style={{ overflow: "hidden" }}
                >
                  <TableHeader adjustForCheckbox={false} displaySelectAll={false} >
                    <TableRow selectable={false}>
                      <TableHeaderColumn style={styles.tituloTablaBusqueda1}>Código<br />Prestación</TableHeaderColumn>
                      <TableHeaderColumn style={styles.tituloTablaBusqueda2}>Glosa Prestación</TableHeaderColumn>
                      <TableHeaderColumn style={styles.tituloTablaBusqueda3}>Código<br />Isapre/Fonasa</TableHeaderColumn>
                      <TableHeaderColumn style={styles.tituloTablaBusqueda4}>Código<br />Profesional</TableHeaderColumn>
                      <TableHeaderColumn style={styles.tituloTablaBusqueda5}>Valor</TableHeaderColumn>
                      <TableHeaderColumn style={styles.tituloTablaBusqueda7}>Unidad</TableHeaderColumn>
                      <TableHeaderColumn style={styles.tituloTablaBusqueda6}>Tipo<br />Atención</TableHeaderColumn>
                      <TableHeaderColumn style={styles.tituloTablaBusqueda8}>Fecha<br />Vigencia Precio</TableHeaderColumn>
                      <TableHeaderColumn style={styles.tituloTablaBusqueda9}>Centro Atención</TableHeaderColumn>
                      <TableHeaderColumn style={styles.tituloTablaBusqueda10}>Editar</TableHeaderColumn>
                      <TableHeaderColumn style={styles.tituloTablaBusqueda11}>Eliminar</TableHeaderColumn>
                    </TableRow>
                  </TableHeader>
                  <TableBody
                    id="tablaBodyBusquedaPrestaciones"
                    displayRowCheckbox={false}
                    deselectOnClickaway={false}
                    stripedRows
                  >
                    {menuListPrestaciones}
                  </TableBody>
                </Table>

              </div>
            </div>
            {itemsNumPages}

            <hr />
          </div>
        }
      </div>
    );
  }
}

PaginacionBD.defaultProps = {
  pageDefault: 1,
  rowsPerPageDefault: 10,
  showRowsPerPage: true,

  labelStyleBtnPage: null,
  overlayStyleBtnPage: null,
  rippleStyleBtnPage: null,
  styleBtnPage: null,
  buttonStyleBtnPage: null,

  styleRowsPerPage: null,
  labelStyleRowsPerPage: null,
  underlineStyleRowsPerPage: null,
  iconStyleRowsPerPage: null,
  menuItemStyleRowsPerPage: null,
  selectedMenuItemStyleRowsPerPage: null,
};

PaginacionBD.propTypes = {
  pageSize: PropTypes.number.isRequired,
  totalPage: PropTypes.number,
  totalRows: PropTypes.number.isRequired,
  pageDefault: PropTypes.number,
  rowsPerPageDefault: PropTypes.number,
  idTableBody: PropTypes.string.isRequired,
  showRowsPerPage: PropTypes.bool,

  labelStyleBtnPage: PropTypes.any,
  overlayStyleBtnPage: PropTypes.any,
  rippleStyleBtnPage: PropTypes.any,
  styleBtnPage: PropTypes.any,
  buttonStyleBtnPage: PropTypes.any,

  styleRowsPerPage: PropTypes.any,
  labelStyleRowsPerPage: PropTypes.any,
  underlineStyleRowsPerPage: PropTypes.any,
  iconStyleRowsPerPage: PropTypes.any,
  menuItemStyleRowsPerPage: PropTypes.any,
  selectedMenuItemStyleRowsPerPage: PropTypes.any,
  parentCallback: PropTypes.any,
  prestacionesPP: PropTypes.array.isRequired,
  tipoArancel: PropTypes.number.isRequired,
  rutInstitucion: PropTypes.number,
  isapre: PropTypes.string.isRequired,
  tablaBusquedaPrestaciones: PropTypes.string,
  tablaBody: PropTypes.string,
  totalPagina: PropTypes.number,

};

const mapStateToProps = (state) => ({
  pageSize: state.paginacionState.pageSize,
  totalPage: state.paginacionState.totalPage,
  prestacionesPP: state.paginacionState.prestacionesPP,
  tipoArancel: state.global.filtros_CAT.tipoArancel || 0,
  rutInstitucion: state.global.rutInstitucion,
  isapre: state.global.isapre,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(PaginacionBD);
